/** How an Inline's packed children sit in its row. */
export type InlineJustify = "start" | "center" | "end";

export interface InlineRowItem {
  readonly id: string;
  readonly x: number;
  readonly w: number;
}

/**
 * Align the items of a one-row grid. They are packed left in their current x
 * order with no gaps, then shifted as a group so the free columns sit after
 * them (start), split before/after with the extra column after when odd
 * (center), or before them (end). Pure: returns new items, input untouched.
 */
export function alignInlineRow<T extends InlineRowItem>(
  items: readonly T[],
  columns: number,
  justify: InlineJustify,
): T[] {
  const sorted = [...items].sort((a, b) => a.x - b.x);
  const used = sorted.reduce((sum, it) => sum + it.w, 0);
  const free = Math.max(0, columns - used);
  const offset =
    justify === "start" ? 0 : justify === "end" ? free : Math.floor(free / 2);
  let x = offset;
  return sorted.map((it) => {
    const placed = { ...it, x };
    x += it.w;
    return placed;
  });
}
